/* ================================================================
   BJ Header — interactions
   - Mega menu hover/click (desktop)
   - Mobile drawer open/close
   - Mobile drawer tabs
   - Search overlay
   - Country/currency selector
   ================================================================ */
(function () {
  'use strict';

  function init() {
    initDesktopMega();
    initMobileDrawer();
    initMobileTabs();
    initMobileDrawerSubmenus();
    initSearchOverlay();
    initLocaleSelector();
  }

  /* ---------- Mobile drawer expandable sub-menus ---------- */
  function initMobileDrawerSubmenus() {
    var toggles = document.querySelectorAll('[data-bj-drawer-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var row = toggle.closest('.bj-header__drawer-row');
        if (!row) return;
        var sub = row.querySelector('.bj-header__drawer-sub');
        if (!sub) return;
        var isOpen = row.classList.contains('is-open');
        if (isOpen) {
          row.classList.remove('is-open');
          sub.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          row.classList.add('is-open');
          sub.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- Desktop mega menu (click to lock open) ---------- */
  function initDesktopMega() {
    var items = document.querySelectorAll('.bj-header__nav-item--has-mega');
    items.forEach(function (item) {
      var link = item.querySelector('.bj-header__nav-link');
      if (!link) return;

      // On desktop, hover handles open/close naturally. Click on the
      // link still navigates to the parent category.
      // Add keyboard focus management.
      link.addEventListener('focus', function () {
        items.forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.add('is-open');
      });
    });

    // Close any open mega when clicking outside the header
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.bj-header__nav-item--has-mega')) {
        items.forEach(function (i) { i.classList.remove('is-open'); });
      }
    });

    // Escape closes mega
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        items.forEach(function (i) { i.classList.remove('is-open'); });
      }
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initMobileDrawer() {
    var drawer = document.getElementById('BjMobileDrawer');
    if (!drawer) return;

    var openButtons = document.querySelectorAll('[data-bj-drawer-open]');
    var closeButtons = document.querySelectorAll('[data-bj-drawer-close]');

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.hidden = false;
        // Force reflow so transform transition runs
        // eslint-disable-next-line no-unused-expressions
        drawer.offsetHeight;
        drawer.setAttribute('data-open', 'true');
        document.body.classList.add('bj-header-drawer-open');
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    function closeDrawer() {
      drawer.setAttribute('data-open', 'false');
      document.body.classList.remove('bj-header-drawer-open');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      // Hide after transition
      setTimeout(function () {
        if (drawer.getAttribute('data-open') === 'false') drawer.hidden = true;
      }, 300);
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    });

    // Close drawer when any link inside it is clicked (navigation)
    drawer.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (link && link.getAttribute('href') && !link.hasAttribute('data-bj-drawer-toggle')) {
        // Let the navigation happen, then close drawer after a tiny delay
        setTimeout(closeDrawer, 50);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        closeDrawer();
      }
    });
  }

  /* ---------- Mobile drawer tabs ---------- */
  function initMobileTabs() {
    var tabs = document.querySelectorAll('[data-bj-tab]');
    var panels = document.querySelectorAll('[data-bj-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-bj-tab');

        tabs.forEach(function (t) {
          var active = t.getAttribute('data-bj-tab') === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          var active = p.getAttribute('data-bj-panel') === idx;
          p.classList.toggle('is-active', active);
          p.hidden = !active;
        });
      });
    });
  }

  /* ---------- Search overlay ---------- */
  function initSearchOverlay() {
    var overlay = document.getElementById('BjSearchOverlay');
    if (!overlay) return;

    var toggles = document.querySelectorAll('[data-bj-search-toggle]');
    var closers = document.querySelectorAll('[data-bj-search-close]');

    function open() {
      overlay.hidden = false;
      document.body.classList.add('bj-header-search-open');
      var input = overlay.querySelector('input[name="q"]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('bj-header-search-open');
    }

    toggles.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
  }

  /* ---------- Country/Currency + Language selectors ---------- */
  function initLocaleSelector() {
    var selectors = [
      { btn: '.bj-header__locale:not(.bj-header__lang) .bj-header__locale-btn', list: 'BjHeaderCountryList', inputName: 'country_code' },
      { btn: '.bj-header__lang .bj-header__locale-btn', list: 'BjHeaderLanguageList', inputName: 'locale_code' }
    ];

    selectors.forEach(function (sel) {
      var btn = document.querySelector(sel.btn);
      var list = document.getElementById(sel.list);
      if (!btn || !list) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !list.hidden;
        list.hidden = isOpen;
        btn.setAttribute('aria-expanded', String(!isOpen));
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest(sel.btn.split(' ')[0])) {
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        }
      });

      list.querySelectorAll('.bj-header__locale-option').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          var form = btn.closest('form');
          if (!form) return;
          var hidden = form.querySelector('input[name="' + sel.inputName + '"]');
          if (hidden) hidden.value = opt.getAttribute('data-value');
          form.submit();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
